import type { Booking, Lead } from "./supabase";
import { humanise } from "./format";

/** Controllers needed for a booking (crew size x crews). */
export const crewNeeded = (b: Booking) => b.crew_size * b.crews;

/** "3-person" or "2 x 2-person". */
export const crewLabel = (b: Booking) => (b.crews > 1 ? `${b.crews} x ${b.crew_size}-person` : `${b.crew_size}-person`);

/**
 * Controllers still to allocate on a confirmed or allocated booking, or null when
 * not applicable (requested, completed, cancelled, or allocations not loaded).
 */
export function crewShortfall(b: Booking): number | null {
  if (!b.allocations || (b.status !== "confirmed" && b.status !== "allocated")) return null;
  const short = crewNeeded(b) - b.allocations.length;
  return short > 0 ? short : null;
}

/** "2-person night, 10 hrs + TGS" from a lead's instant-quote estimate, or null when it has none. */
export function estimateSummary(l: Lead): string | null {
  const labour = l.estimate_input?.labour;
  const extras = (l.estimate_input?.services ?? []).map((s) => s.code);
  const parts: string[] = [];
  if (labour?.crewSize) {
    const shift = labour.shiftType ? ` ${humanise(labour.shiftType).toLowerCase()}` : "";
    const crews = labour.crews && labour.crews > 1 ? `${labour.crews} x ` : "";
    parts.push(`${crews}${labour.crewSize}-person${shift}${labour.hours ? `, ${labour.hours} hrs` : ""}`);
  }
  if (extras.length) parts.push(parts.length ? `+ ${extras.join(", ")}` : extras.join(", "));
  return parts.length ? parts.join(" ") : null;
}
